import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { WindowSizeService } from '@ally/remarketing/shared/services';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DesktopOnlyGuard  {
  constructor(private readonly windowSizeService: WindowSizeService, private readonly router: Router) {}

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.windowSizeService.windowSize$().pipe(
      map(size => {
        if (!size.isDesktop()) {
          // This is brittle, as the base URL is defined by `webcore`, not the library
          return this.router.createUrlTree(['profile-management']);
        }
        return true;
      })
    );
  }
}
